export class PendingCompanyError extends Error {}
